const initialState = {
  sectionsList: [],
  currentSection: 0,
  questionsHistory: [],
  currentQuestion: 0,
  branchingLogics: []
}

export default initialState
